const LogoBgAnimatedVector = ({ color }) => {
  return (
    <svg
      width="584"
      height="492"
      viewBox="0 0 584 492"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="logo-bg-animated-vector"
    >
      <path
        d="M467.679 0L302.179 297L334.679 0H234.679L273.679 297L131.679 0L0 94.5213L264.679 315.5L1.91644 222.29L2.75813 336.911L264.679 339L35.212 384.115L75.5997 491.551L263.569 353.407L322.176 348.616L547.179 453L573.679 367L334.679 339L583.179 283L564.179 165.5L319.105 311.051L547.179 87.5L467.679 0Z"
        fill="url(#paint0_radial_1880_20)"
        fillOpacity="0.2"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1880_20"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(298.097 329.013) rotate(-92.9155) scale(391.184 466.524)"
        >
          <stop stopColor={color || "#fff"} />
          <stop offset="0.794779" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export default LogoBgAnimatedVector;
